module.exports = __webpack_public_path__ + "static/media/wcolor_bg_03.d2f99d58.png";